export interface AvatarProps {
  /** Person or project name; used for initials and the accessible label. */
  name: string;
  /** Optional image URL. Falls back to colored initials when absent. */
  src?: string;
  size?: number;
  className?: string;
}

const PALETTE = ['#ff7a4d', '#5b7cfa', '#1fae6f', '#e0930f', '#e5484d', '#9b5de5', '#00b4d8'];

function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
}

function colorFor(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) | 0;
  return PALETTE[Math.abs(hash) % PALETTE.length]!;
}

/** A circular avatar showing an image, or deterministic colored initials. */
export function Avatar({ name, src, size = 40, className }: AvatarProps) {
  const style = {
    width: size,
    height: size,
    fontSize: Math.round(size * 0.4),
    background: src ? undefined : colorFor(name),
  };
  return (
    <span
      className={['pt-avatar', className].filter(Boolean).join(' ')}
      style={style}
      role="img"
      aria-label={name}
    >
      {src ? <img src={src} alt="" /> : initials(name)}
    </span>
  );
}
